// 账号
let codeReg = /^(?![0-9]*$)(?![a-zA-Z]*$)[a-zA-Z0-9]{6,20}$/
// 电话
let phoneReg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/

// 必须为数字
let numberReg = /^\d+$|^\d+[.]?\d+$/

// 密码
let passwordReg = /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$)([^\u4e00-\u9fa5\s]){6,20}$/

// 联系人
let contactsReg = /^[\u0391-\uFFE5A-Za-z]+$/

let regId = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/

let emailReg = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/

let sLangPrefix = 'formValidate';

let FormValidate = (function () {
  function FormValidate() { }
  // From表单验证规则  可用于公用的校验部分
  FormValidate.Form = function () {
    return {
      // 必填的验证规则
      validateRequired(rule, value, callback, msg, formTipArray) {
      if(msg === '部门'){
        console.log("rule:"+rule);
        console.log("value:"+value);
      }
      let isPass = false
        if (Object.prototype.toString.call(value) == '[object Array]') {
          if (value && value.length === 0) {
            isPass = false
          } else {
            isPass = true
          }
        } else {
          if (value === '' || value === undefined || value === null) {
            isPass = false
          } else {
            isPass = true
          }
        }

        if (isPass) {
          callback()
        } else {
          let flag = true;
          for (let i = 0; i < formTipArray.length; i++) {
            if (msg === formTipArray[i]) {
              flag = false;
              break;
            }
          }
          if (flag) {
            formTipArray.push(msg);
          }
          callback(new Error(msg))
        }
      },
      // 必填的验证规则-反向
      validateRequiredReverse(rule, value, callback, msg, formTipArray) {
        console.log('2019年09月12日14:34:03 rules.js[进入反向公共规则校验]——[msg] :', msg);
        if (value === '' || value === undefined || value === null) {
          callback()
          console.log('rules.js[验证不通过，输入必须为空]——msg :', msg);
        } else {
          console.log('rules.js[验证通过，输入为空]——msg :', msg);
          formTipArray.push(msg)
          console.log('rules.js[验证通过，输入为空]——formTipArray :', formTipArray);
          callback(new Error('输入不能为空'))
        }
      },
      // 账号的验证规则
      validateCode(rule, value, callback) {
        if (!value) {
          return callback(new Error('请输入账号'))
        }
        if (!codeReg.test(value)) {
          callback(new Error('账号必须为6-20位字母和数字组合'))
        } else {
          callback()
        }
      },

      // 只能数字的验证
      validateNumber(rule, value, callback, msg) {
        console.log('rules.js[进入数字验证]——value :', value);
        console.log('rules.js[进入数字验证]——msg :', msg);
        if (value !== '') {
          if (!numberReg.test(value)) {
            callback(new Error('员工数量必须为数字'))
          } else {
            callback()
          }
        } else {
          callback(new Error('输入不能为空'))
        }
      },

      // 密码的验证
      validatePsdReg(rule, value, callback) {
        if (!value) {
          return callback(new Error('请输入密码'))
        }
        if (!passwordReg.test(value)) {
          callback(new Error('请输入6-20位英文字母、数字或者符号（除空格），且字母、数字和标点符号至少包含两种'))
        } else {
          callback()
        }
      },

      // 联系人
      validateContacts(rule, value, callback) {
        if (!value) {
          return callback(new Error('请输入联系人'))
        }
        if (!contactsReg.test(value)) {
          callback(new Error('联系人不可输入特殊字符'))
        } else {
          callback()
        }
      },

      // 邮箱的验证规则
      validateEmail(rule, value, callback, vm) {
        if (!value) {
          return callback();
        }

        let isPass = false;

        if (emailReg.test(value)) {
          isPass = true;
        }

        if (isPass) {
          callback();
        } else {
          let tipmsg = vm.$t(sLangPrefix + '.email');
          let msg = rule.elementLabelInfo.label + "," + vm.formatMessage(tipmsg, []);

          if (!vm.formTipArray.includes(msg)) {
            vm.formTipArray.push(msg);
          }
          callback(new Error(msg))
        }  
      },

      // 电话号码的验证
      validatePhone(rule, value, callback, vm) {
        if (!value) {
          return callback();
        }

        let isPass = false;

        if (phoneReg.test(value)) {
          isPass = true;
        }

        if (isPass) {
          callback();
        } else {
          let tipmsg = vm.$t(sLangPrefix + '.phone');
          let msg = rule.elementLabelInfo.label + "," + vm.formatMessage(tipmsg, []);

          if (!vm.formTipArray.includes(msg)) {
            vm.formTipArray.push(msg);
          }
          callback(new Error(msg))
        }       
      },

      // 身份证的验证规则
      ID(rule, value, callback, vm) {
        if (!value) {
          return callback();
        }

        let isPass = false;

        if (regId.test(value)) {
          isPass = true;
        }

        if (isPass) {
          callback();
        } else {
          let tipmsg = vm.$t(sLangPrefix + '.idcard');
          let msg = rule.elementLabelInfo.label + "," + vm.formatMessage(tipmsg, []);

          if (!vm.formTipArray.includes(msg)) {
            vm.formTipArray.push(msg);
          }
          callback(new Error(msg))
        }
      },
      // 检查最长字符长度限制
      maxCharLength(rule, value, callback, vm) {
        let methodInfo = rule.methodInfo;
        if (!methodInfo.methodparam) {
          throw new Error("请配置函数参数!");
        }

        let isPass = false;
        let param = methodInfo.methodparam;
        let iLength = param * 3;
        iLength = parseInt((iLength > 4000 ? 4000 : iLength) / 3);

        let sValue = value ? value+'' : '';
        sValue = sValue.trim();

        if (sValue.length <= iLength) {
          isPass = true;
        }

        if (isPass) {
          callback();
        } else {
          let tipmsg = vm.$t(sLangPrefix + '.maxCharLength');
          let msg = rule.elementLabelInfo.label + "," + vm.formatMessage(tipmsg, param);
          if (!vm.formTipArray.includes(msg)) {
            vm.formTipArray.push(msg);
          }
          callback(new Error(msg))
        }
      },
      // 通过校验
      validatePass(rule, value, callback, msg, formTipArray) {
        callback();
      },
      // 检查最短字符长度限制
      minCharLength(rule, value, callback, vm) {
        let methodInfo = rule.methodInfo;
        if (!methodInfo.methodparam) {
          throw new Error("请配置函数参数!");
        }

        let isPass = false;
        let param = methodInfo.methodparam;
        let iLength = param * 3;
        iLength = parseInt((iLength > 4000 ? 4000 : iLength) / 3);

        let sValue = value ? value+'' : '';
        sValue = sValue.trim();

        if (sValue.length >= iLength) {
          isPass = true;
        }

        if (isPass) {
          callback();
        } else {
          let tipmsg = vm.$t(sLangPrefix + '.minCharLength');
          let msg = rule.elementLabelInfo.label + "," + vm.formatMessage(tipmsg, param);
          if (!vm.formTipArray.includes(msg)) {
            vm.formTipArray.push(msg);
          }
          callback(new Error(msg))
        }
      },
      // 验证值的整数、小数位数. e.g. decimal:[3,2]
      decimal(rule, value, callback, vm) {
        if (!value) {
          return callback();
        }

        let methodInfo = rule.methodInfo;
        if (!methodInfo.methodparam) {
          throw new Error("请配置函数参数!");
        }

        let isPass = false;
        let param = methodInfo.methodparam;
        let r = null;
        if (param[1] <= 0) {
          r = new RegExp('^([+-]?\\d{1,' + param[0] + '})$');
        } else {
          r = new RegExp('^([+-]?\\d{1,' + param[0] + '})$|^([+-]?\\d{1,' + param[0] + '}\\.\\d{1,' + param[1] + '})$');
        }

        if (r.test(value)) {
          isPass = true;
        }

        if (isPass) {
          callback();
        } else {
          let msg = '';
          if (param[1] <= 0) {
            let tipmsg = vm.$t(sLangPrefix + '.decimal1');
            msg = rule.elementLabelInfo.label + "," + vm.formatMessage(tipmsg, param[0]);
          } else {
            let tipmsg = vm.$t(sLangPrefix + '.decimal2');
            msg = rule.elementLabelInfo.label + "," + vm.formatMessage(tipmsg, param);
          }

          if (!vm.formTipArray.includes(msg)) {
            vm.formTipArray.push(msg);
          }
          callback(new Error(msg))
        }
      },
      // 只能输入整数. e.g. integer: 3
      integer(rule, value, callback, vm) {
        if (!value) {
          return callback();
        }
        
        let methodInfo = rule.methodInfo;
        if (!methodInfo.methodparam) {
          throw new Error("请配置函数参数!");
        }

        let isPass = false;
        let param = methodInfo.methodparam;
        let r = new RegExp('^([+-]?\\d{1,' + param + '})$');

        if (r.test(value)) {
          isPass = true;
        }

        if (isPass) {
          callback();
        } else {
          let tipmsg = vm.$t(sLangPrefix + '.integer');
          let msg = rule.elementLabelInfo.label + "," + vm.formatMessage(tipmsg, param);

          if (!vm.formTipArray.includes(msg)) {
            vm.formTipArray.push(msg);
          }
          callback(new Error(msg))
        }
      },
      // 正数
      positive(rule, value, callback, vm) {
        if (!value) {
          return callback();
        }

        let isPass = false;
        let r = new RegExp('^([^-]?[\\d.]+)$');

        if (r.test(value)) {
          isPass = true;
        }

        if (isPass) {
          callback();
        } else {
          let tipmsg = vm.$t(sLangPrefix + '.positive');
          let msg = rule.elementLabelInfo.label + "," + vm.formatMessage(tipmsg, []);

          if (!vm.formTipArray.includes(msg)) {
            vm.formTipArray.push(msg);
          }
          callback(new Error(msg))
        }
      },
      // 负数
      negative(rule, value, callback, vm) {
        if (!value) {
          return callback();
        }

        let isPass = false;
        let r = new RegExp('^(-[\\d.]+)$');

        if (r.test(value)) {
          isPass = true;
        }

        if (isPass) {
          callback();
        } else {
          let tipmsg = vm.$t(sLangPrefix + '.negative');
          let msg = rule.elementLabelInfo.label + "," + vm.formatMessage(tipmsg, []);

          if (!vm.formTipArray.includes(msg)) {
            vm.formTipArray.push(msg);
          }
          callback(new Error(msg))
        }
      },
      // 自定义方法
      handler(rule, value, callback, vm) {
        let methodInfo = rule.methodInfo;
        if (!methodInfo.methodparam) {
          throw new Error("请配置自定义函数名!");
        }

        let aMethod = [];
        let sMethodName = "";
        if (methodInfo.methodparam.includes(',')) {
          aMethod = methodInfo.methodparam.split(',');
          sMethodName = aMethod[0];
        } else {
          sMethodName = methodInfo.methodparam;
        }

        vm[sMethodName](rule, value).then(function (isPass) {
          if (isPass) {
            callback();
          } else {
            let tipmsg = '';
            let msg = '';
            if (methodInfo.methodparam.includes(',')) {
              tipmsg = methodInfo.message;
              if (!methodInfo.message) {
                tipmsg = '{0}';
              }
              let vErrorMsg = vm[aMethod[1]](rule, value);
              msg = vm.formatMessage(tipmsg, vErrorMsg);
            } else {
              tipmsg = methodInfo.message;
              if (!methodInfo.message) {
                tipmsg = vm.$t(sLangPrefix + '.handler');
              }
              msg = vm.formatMessage(tipmsg, methodInfo.methodparam);
            }

            if (!vm.formTipArray.includes(msg)) {
              vm.formTipArray.push(msg);
            }
            callback(new Error(msg))
          }
        });
      }
    }
  }

  return FormValidate
}())

exports.FormValidate = FormValidate


// WEBPACK FOOTER //
// ./src/js/rules.js